import React from 'react';
import { useUser } from 'shared/hooks/use-user';
import { TodayGroupBy } from 'shared/types/sorting-mode';

import { ActiveFilterBanner } from '../active-filter-banner';
import { CompletedTasks } from '../completed-tasks';
import { DayPartGroupingTasksList } from '../day-part-grouping-tasks-list';
import { ExternalCalendarEvents } from '../external-calendar-events';
import { GoalGroupingTasksList } from '../goal-grouping-tasks-list';
import { LifeAreaGroupingTasksList } from '../life-area-grouping-tasks-list';
import { NoGroupingTasksList } from '../no-grouping-tasks-list';
import { PageTopBar } from '../page-top-bar';
import { PriorityGroupingTasksList } from '../priority-grouping-tasks-list';
import { TypeGroupingTasksList } from '../type-grouping-tasks-list';
import * as Styled from './grouped-list.style';

const groupByLists: Record<TodayGroupBy, React.FC> = {
  [TodayGroupBy.None]: NoGroupingTasksList,
  [TodayGroupBy.DayPart]: DayPartGroupingTasksList,
  [TodayGroupBy.Goal]: GoalGroupingTasksList,
  [TodayGroupBy.LifeArea]: LifeAreaGroupingTasksList,
  [TodayGroupBy.Priority]: PriorityGroupingTasksList,
  [TodayGroupBy.Type]: TypeGroupingTasksList,
};

export type GroupedListProps = {
  onCalendar: () => void;
  calendarOpen?: boolean;
};

export const GroupedList: React.FC<GroupedListProps> = ({
  onCalendar,
  calendarOpen,
}) => {
  const user = useUser();

  const TaskListComponent =
    groupByLists[user?.settings?.todayGroupBy ?? TodayGroupBy.None] ??
    groupByLists[TodayGroupBy.None];

  return (
    <>
      <PageTopBar onCalendar={onCalendar} calendarOpen={calendarOpen} />

      <Styled.Content>
        <Styled.MetaContainer>
          <ExternalCalendarEvents
            show={!user?.settings?.todayHideDesktopExternalCalendarEvents}
          />
          <ActiveFilterBanner />
        </Styled.MetaContainer>

        <TaskListComponent />

        <CompletedTasks />
      </Styled.Content>
    </>
  );
};
